import Ladda from 'ladda';

let ladda;
let waypoint;

const _initFlagging = function _initFlagging() {
  $('body').on('click', '.js-community-flag', (e) => {
    const $currentTarget = $(e.currentTarget);
    const questionId = $currentTarget.data('question-id');
    const commentId = $currentTarget.data('comment-id');
    const type = $currentTarget.data('type');

    const $modal = $('#modal--flag');
    $modal.find('.js-comment-flag-spam').data('question-id', questionId);
    $modal.find('.js-comment-flag-spam').data('comment-id', commentId);
    $modal.find('.js-comment-flag-spam').data('type', type);

    $modal.find('.js-comment-flag-abusive').data('question-id', questionId);
    $modal.find('.js-comment-flag-abusive').data('comment-id', commentId);
    $modal.find('.js-comment-flag-abusive').data('type', type);

    $modal.find('.js-comment-flag-not-like').data('question-id', questionId);
    $modal.find('.js-comment-flag-not-like').data('comment-id', commentId);
    $modal.find('.js-comment-flag-not-like').data('type', type);

    $currentTarget.trigger('vs:ui:community:flag:toggle');
  });

  $('#modal--flag').on('click', 'button:not(button.btn-close)', (e) => {
    const type = $(e.currentTarget).data('type');
    if (type === 'comment') {
      $(e.currentTarget).trigger('vs:app:community:flag', true);
    } else if (type === 'question') {
      $(e.currentTarget).trigger('vs:app:community:flag', false);
    }
  });

  $('body').on('vs:ui:community:flag:toggle', () => {
    $('#modal--flag').modal('toggle');
  });

  $('body').on('vs:ui:community:flag:flagged', (e) => {
    $(e.target)
      .addClass('flag--selected')
      .removeClass('btn--grey')
      .addClass('btn--black')
    ;
    $(e.target).html('<i class="md-flag"></i> Flagged');
  });
};

const _initSharing = function _initSharing() {
  $('body').on('click', '.js-community-share', (e) => {
    $(e.currentTarget).trigger('vs:app:community:share');
  });

  $('body').on('click', '.share-wrapper', (e) => {
    $(e.currentTarget)
      .toggleClass('share-wrapper--selected')
    ;
  });

  $('body').on('click', '.js-toggle-share--inline', (e) => {
    $(e.currentTarget)
      .parents('.comment__item__actions__share')
      .toggleClass('comment__item__actions__share--selected')
    ;
  });
};

const _initComments = function _initComments() {
  $('#comments').on('vs:ui:community:comment:new:clear', (e) => {
    // Clear textarea
    $(e.currentTarget)
      .find('.comment__new__textarea')
      .val('')
    ;
  });
};

const _initCommentSeeMore = function _initCommentSeeMore() {
  $('#comments__see-more').on('vs:ui:community:comment:see_more:start', (e) => {
    $(e.currentTarget).prop('disabled', true);
    ladda = Ladda.create(document.querySelector('#comments__see-more__label'));
    ladda.start();
  });

  $('#comments__see-more').on('vs:ui:community:comment:see_more:stop', (e) => {
    $(e.currentTarget).prop('disabled', false);
    ladda.stop();
    $(e.currentTarget).trigger('vs:ui:community:comment:see_more:waypoints:init');
  });

  $('#comments__see-more').on('vs:ui:community:comment:see_more:waypoints:init', (e) => {
    if ($(window).width() > 544) {
      if (waypoint) {
        Waypoint.refreshAll();
      } else {
        waypoint = $('#comments__see-more').waypoint({
          handler(direction) {
            if (!$('#comments__see-more').prop('disabled')) {
              $('#comments__see-more').trigger('vs:app:community:comment:load_more');
            }
          },
          offset: 'bottom-in-view',
        });
      }
    }
  });

  $('#comments__see-more').on('vs:ui:community:comment:see_more:waypoints:destroy', (e) => {
    $(e.currentTarget).hide();
    $(e.currentTarget).prop('disabled', true);
    if (waypoint) {
      Waypoint.destroyAll();
    }
  });

  $('#comments').on('click', '.comment__item__content__see-more', (e) => {
    e.preventDefault();
    const comment = $(e.currentTarget).parent();
    comment.trigger('destroy');
    comment.css('max-height', 'none');
  });
};

const _initCommentLike = function _initCommentLike() {
  $('#comments').on('click', '.comment__item__recommend', (e) => {
    e.preventDefault();
    const target = $(e.currentTarget);
    if (!target.parent('.comment__item').hasClass('deleted')) {
      target.trigger('vs:app:video:comment:like');
    }
  });
};

const _initCommentReply = function _initCommentReply() {
  $('#comments').on('vs:ui:community:comment:reply:toggle', (e) => {
    const target = $(e.target);
    let replyBox = target.parents('.comment__item').children('.comment__reply');
    if (!replyBox.length) {
      replyBox = target.parent('.comment__reply');
    }
    replyBox.toggleClass('hidden');
    replyBox.find('.comment__new__textarea').focus();
  });
};

const _initCommentDelete = function _initCommentDelete() {
  $('#comments').on('vs:ui:community:comment:delete:toggle', (e) => {
    $('#modal--delete-comment-confirm').modal('toggle');
    $('#modal--delete-comment-confirm')
      .find('comment__delete__delete')
      .focus()
    ;
  });

  $('#comments').on('click', '.comment__item__delete', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const commentId = $(e.target).data('id');
    $('#modal--delete-comment-confirm .comment__delete__delete').data('id', commentId);
    $(e.target).trigger('vs:ui:community:comment:delete:toggle');
  });

  $('body').on('click', '#modal--delete-comment-confirm .comment__delete__delete', (e) => {
    const commentId = $(e.target).data('id');
    // FIXME: Don't do this! Use e.target?
    $('#comments').trigger('vs:app:community:comment:delete', commentId);
  });
};

const _bindUIActions = function _bindUIActions() {
};

const registerEventBindings = function registerEventBindings() {
  _initFlagging();
  _initSharing();

  _initComments();
  _initCommentSeeMore();
  _initCommentLike();
  _initCommentReply();
  _initCommentDelete();

  _bindUIActions();
};

const UICommunity = {
  registerEventBindings,
};

export default UICommunity;
